import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { Modal, ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteModal from "../Common/DeleteModal";

const CustomerList = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;
  const [viewItem, setViewItem] = useState(null);
  const navigate = useNavigate()
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const toggleStatus = async (id, currentStatus) => {
    dispatch(loadingTrue());

    // Logic: active-ah iruntha inactive-nu anupu, illana active-nu anupu
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    console.log("Sending Data:", { id, status: newStatus }); // Itha check pannu machan

    const res = await Handler({
      method: "post",
      url: "/customer/update.php",
      data: { id, status: newStatus }
    });

    if (res.success) {
      loadCustomers();
    }
    dispatch(loadingFalse());
  };


  const loadCustomers = async () => {
    dispatch(loadingTrue());
    const offset = (page - 1) * limit;

    const res = await Handler({ method: "get", url: `/customer/list.php?limit=${limit}&offset=${offset}&search=${search}&status=all` });
    if (res?.success) {
      setData(res?.data || []);
      setTotal(res.total_count || res.total || 0);
    }
    dispatch(loadingFalse());
  };

  useEffect(() => { loadCustomers(); }, [page, search]);

  return (
    <div className="page-card">

      <div className="page-header">
        <h4>Customers</h4>
        <div className="search-box">
          <i className='bx bx-search'></i>
          <input
            placeholder="Search customers..."
            value={search}
            onChange={e => { setPage(1); setSearch(e.target.value) }}
          />
        </div>
      </div>

      <div className="table-wrap">
        <table className="table modern-table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Company</th>
              <th>Person Incharge</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Status</th>
              <th>Date</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {data?.length === 0 ? (
              <tr><td colSpan="7" className="text-center">No customers found</td></tr>
            ) : data?.map(c => (
              <tr key={c.id}>
                <td className="fw-semibold text-nowrap">{c.customer_code}</td>
                <td style={{ maxWidth: '180px' }} className="text-truncate" title={c.company_name}>{c.company_name}</td>
                <td style={{ maxWidth: '140px' }} className="text-truncate" title={c.contact_person}>{c.contact_person}</td>
                <td className="text-nowrap">{c.phone}</td>
                <td style={{ maxWidth: '180px' }} className="text-lowercase text-truncate" title={c.email}>{c.email}</td>
                <td>
                  <span className={`status-badge text-capitalize ${c.status}`}>
                    {c?.status}
                  </span>
                </td>
                <td className="text-nowrap">{new Date(c.created_at).toLocaleDateString()}</td>
                <td className="text-center">
                  <div className="d-inline-flex align-items-center justify-content-center gap-1 text-nowrap">
                    <label className="switch me-1" title="Toggle Status">
                      <input type="checkbox" checked={c.status === "active"} onChange={() => toggleStatus(c.id, c.status)} />
                      <span className="slider"></span>
                    </label>
                    <button className="icon-btn view" title="View Customer" onClick={() => setViewItem(c)}>
                      <i className='bx bx-show'></i>
                    </button>
                    <button className="icon-btn edit" title="Edit Customer"
                      onClick={() => navigate(`/customers/edit/${c.id}`)}>
                      <i className='bx bx-edit'></i>
                    </button>
                    <button className="icon-btn text-danger" title="Delete Customer"
                      onClick={() => setDeleteTarget(c)}>
                      <i className='bx bx-trash'></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination
        page={page}
        total={total}
        limit={limit}
        onPrev={() => setPage(p => Math.max(1, p - 1))}
        onNext={() => setPage(p => p + 1)}
      />
      <Modal isOpen={!!viewItem} toggle={() => setViewItem(null)} centered size="md" className="extraordinary-modal">
        <ModalBody className="p-0 overflow-hidden">
          <div className="modal-banner">
            <div className="banner-content">
              <div className="customer-icon">
                <i className='bx bxs-user-detail'></i>
              </div>
              <div className="header-text">
                <h5>{viewItem?.company_name}</h5>
                <p>{viewItem?.customer_code}</p>
              </div>
            </div>
            <button className="glass-close" onClick={() => setViewItem(null)}>
              <i className='bx bx-x'></i>
            </button>
          </div>

          <div className="modal-body-premium">
            <div className="info-grid">
              <div className="info-item">
                <i className='bx bx-id-card'></i>
                <div>
                  <span>UEN Number</span>
                  <strong>{viewItem?.uen || 'N/A'}</strong>
                </div>
              </div>
              <div className="info-item">
                <i className='bx bx-user'></i>
                <div>
                  <span>Contact Person</span>
                  <strong>{viewItem?.contact_person}</strong>
                </div>
              </div>
              <div className="info-item">
                <i className='bx bx-phone'></i>
                <div>
                  <span>Phone Number</span>
                  <strong>{viewItem?.phone}</strong>
                </div>
              </div>
              <div className="info-item">
                <i className='bx bx-envelope'></i>
                <div>
                  <span>Email Address</span>
                  <strong>{viewItem?.email}</strong>
                </div>
              </div>
              <div className="info-item full-width">
                <i className='bx bx-map-pin'></i>
                <div>
                  <span>Billing Address</span>
                  <strong className="text-capitalize">{viewItem?.billing_address}</strong>
                </div>
              </div>
            </div>

            <div className="status-footer">
              <div className="status-section">
                <span>Account Status</span>
                <div className={`status-badge ${viewItem?.status}`}>
                  <span className="dot"></span> {viewItem?.status}
                </div>
              </div>

              <div className="action-btns">
                <button className="edit-action-btn edit"
                  onClick={() => navigate(`/customers/edit/${viewItem?.id}`)}>
                  <i className='bx bx-edit'></i>
                </button>
                <button className="close-action-btn" onClick={() => setViewItem(null)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <DeleteModal
        isOpen={!!deleteTarget}
        toggle={() => setDeleteTarget(null)}
        title="Delete Customer"
        message={`Are you sure you want to delete customer ${deleteTarget?.company_name || ''}?`}
        onConfirm={async () => {
          if (!deleteTarget) return;
          setDeleting(true);
          dispatch(loadingTrue());
          const res = await Handler({
            method: "delete",
            url: "/customer/delete.php",
            data: { id: deleteTarget.id }
          });
          dispatch(loadingFalse());
          setDeleting(false);
          if (res?.success) {
            setDeleteTarget(null);
            toast.success(res?.message || "Customer deleted successfully");
            setData(prevData => prevData.filter(c => String(c.id) !== String(deleteTarget.id)));
            loadCustomers();
          } else {
            setDeleteTarget(null);
            toast.error(res?.message || "Failed to delete customer");
          }
        }}
        loading={deleting}
      />
    </div>

  );
};

export default CustomerList;
